<template>
  <div class="page bg-color">
    <van-sticky>
      <div class="market-search">
        <div class="market-search-ipt">
          <van-search v-model="nameStr" shape="round" :placeholder="t('market.a1')" @clear="clear"
            @blur="onClickButton">
            <template #right-icon>
              <div @click="onClickButton">{{ t('market.a2') }}</div>
            </template>
          </van-search>
        </div>
      </div>
    </van-sticky>
    <RollingIndex2 :list="indexs" />
    <div class="list-page">
      <div class="trade-tbas" ref="tabWrap">
        <div :class="{ 'trade-tbas-is': active == 0 }" ref="tabRefs0" @click="tabChange(0)"> {{ t('market.a3') }} </div>
        <!-- <div :class="{ 'trade-tbas-is': active == 1 }" ref="tabRefs1" @click="tabChange(1)"> {{ t('market.a4') }} </div> -->
        <div :class="{ 'trade-tbas-is': active == 2 }" ref="tabRefs2" @click="tabChange(2)"> {{ t('market.a5') }} </div>
        <!-- <div :class="{ 'trade-tbas-is': active == 3 }" ref="tabRefs3" @click="tabChange(3)"> {{ t('market.a6') }} </div> -->
        <div :class="{ 'trade-tbas-is': active == 4 }" ref="tabRefs4" @click="tabChange(4)"> {{t('market.a15')}}</div>
        <div :class="{ 'trade-tbas-is': active == 5 }" ref="tabRefs5" @click="tabChange(5)"> {{t('market.a16')}} </div>
        <div :class="{ 'trade-tbas-is': active == 6 }" ref="tabRefs6" @click="tabChange(6)">{{t('market.a17')}} </div>
      </div>
      <div class="list-th" v-if="active != 3">
        <div>{{ t('market.a7') }}</div>
        <div style="text-align: center;display: flex;align-items: center;">
          {{ active != 0 ? t('index.a12', { value: active == 1 ? 'ARS' : 'USD' }) : t('market.a10') }}
          <div class="list-th-right-icon" @click="sortClick('price')">
            <van-icon class="icon" name="arrow-up"
              :style="`color:${sort == 1 && sort_field == 'price' ? '#2969FF' : '#000'}`" />
            <van-icon class="icon icon-fall" name="arrow-down"
              :style="`color:${sort == 2 && sort_field == 'price' ? '#2969FF' : '#000'}`" />
          </div>
        </div>
        <div class="list-th-right">
          <div style="width: fit-content;display: flex;align-items: center;">{{ t('market.a9') }}</div>
          <div class="list-th-right-icon" @click="sortClick('changes_percentage')">
            <van-icon class="icon" name="arrow-up"
              :style="`color:${sort == 1 && sort_field == 'changes_percentage' ? '#2969FF' : '#000'}`" />
            <van-icon class="icon icon-fall" name="arrow-down"
              :style="`color:${sort == 2 && sort_field == 'changes_percentage' ? '#2969FF' : '#000'}`" />
          </div>
        </div>
      </div>
      <van-list :key="key" v-model:loading="loading" :finished="finished" :loading-text="t('loading.a1')"
        :finished-text="t('loading.a2')" @load="onLoad">
        <div class="list" v-if="active != 3">
          <div class="list-row" v-for="v in list" :key="v.id" @click="router.push('/marketDetail?id=' + v.id)">
            <div class="list-col1">
              <img src="@/assets/images/scactive.svg" @click.stop="stockToggleClick(v)" v-if="v.collect" alt=""
                class="mr-0.2rem cursor-pointer">
              <img src="@/assets/images/sc.png" alt="" @click.stop="stockToggleClick(v)" v-else
                class="mr-0.2rem cursor-pointer">
              <img v-lazy="v.logo" alt="">
              <div class="stock-name">
                <div>{{ v.short_name }}</div>
                <div>{{ v.name }}</div>
              </div>
            </div>
            <div class="list-col2">
              <div class="list-text1"> {{ Number(v.price).toFixed(active == 1 ? 2 : 3) }} </div>
            </div>
            <div class="list-col3">
              <div class="list-text2" :class="{ zhang: v.changes_percentage * 100 < 0 }">
                {{ Number(v.changes_percentage).toFixed(2) }}% </div>
            </div>
          </div>
        </div>
        <!-- <div class="news-item" v-if="active == 3" @click="newsClick(v)" v-for="v in list" :key="v.id">
          <div class="right">
            <div class="news-item-title"> {{ v.name }} </div>
            <div class="news-item-footer">
              <div class="news-item-footer-left"> {{ v.created_at }} </div>
            </div>
          </div>
          <div class="news-item-img"><img alt="" v-lazy="v.cover_img"></div>
        </div> -->
        <!-- 无图片的新闻卡片 -->
        <div class="news-item no-image" v-if="active == 3" v-for="(v, id) in list" :key="v.id" @click="newsClick(v)">
          <div class="news-content">
            <div class="news-item-title">{{ v.name }}</div>
            <div class="news-item-summary" v-if="v.content">
              {{ v.content.slice(0, 100) }}{{ v.content.length > 100 ? '...' : '' }}
            </div>
            <div class="news-item-tags" v-if="v.tags">
              <div class="tags">
                <span v-for="(tag, i) in v.tags.slice(0, 2)" :key="i" class="tag">
                  {{ tag }}
                </span>
              </div>
              <div class="sentiment" :class="{
                positive: v.sentiment?.polarity > 0.3,
                negative: v.sentiment?.polarity < -0.3
              }">
                <span v-if="v.sentiment?.polarity > 0.3">🟢 {{ t('market.a12') }}</span>
                <span v-else-if="v.sentiment?.polarity < -0.3">🔴 {{ t('market.a13') }}</span>
                <span v-else>⚪️ {{ t('market.a14') }}</span>
              </div>
            </div>

            <!-- 时间 -->
            <div class="news-item-footer">
              <div class="news-item-footer-left">
                {{ v.created_at }}
              </div>
              <div class="read-more">{{ t('market.a11') }} →</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
  <BackToTop />
</template>

<script setup name="marketPage">
import { send } from '@/ws'
import { useIndexWS } from '@/composables/useIndexWS'
import { usePolling } from "@/hooks/usePolling"
import { indexsList, stockListCollect, stockList, stockToggle, articleList, stockPrice } from "@/api"
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n"
import { showSuccessToast } from "vant"
import { useMainStore } from "@/store"
const mainStore = useMainStore()
const { t } = useI18n()

const router = useRouter()
const route = useRoute()

const nameStr = ref(''); //搜索
const clear = (val) => {
  // console.log(5);
  sousuoChange()
};
const onClickButton = (value) => {
  sousuoChange()
};
function sousuoChange() {
  list.value = []
  page.value = 1
  finished.value = false
  loading.value = false
  if (active.value != 1 && active.value != 2) {
    active.value = 2
  }
  key.value = !key.value
}

const active = ref(2)
const key = ref(false)
const indexs = ref([])
let webSocketSendSubsIndexs = [] //指数
let webSocketSendSubs = [] // 股票
function getIndexsList() {
  indexsList().then(res => {
    if (res.code == 200) {
      indexs.value = res.data.list
      webSocketSendSubsIndexs = indexs.value.map(v => {
        return { type: 'index', symbol: v.cfd_t }
      })
      let subs = webSocketSendSubs.concat(webSocketSendSubsIndexs)
      send({
        action: 'subscribe',
        subs: subs
      })
    }
  })
}

if (route.query.active == 3) {
  active.value = route.query.active
} else {
  if (mainStore.is_collect == 1) {
    active.value = 0
  }
}

//列表
const list = ref([]);
const loading = ref(false);
const finished = ref(false);
const page = ref(1)
const size = ref(10)
const sort = ref(0)
const sort_field = ref(undefined)
const onLoad = () => {
  if (active.value == 0) {
    getShoucang()
  } else if (active.value == 1 || active.value == 2) {
    getStockList()
  } else {
    getArticleList()
  }
};

// 获取最新价格
let stock_symbolList = []
function getStockPrice() {
  if (stock_symbolList.length <= 0) {
    return
  }
  stockPrice({
    stock_symbol: stock_symbolList
  }).then(res => {
    if (res.code == 200) {
      list.value.forEach((v) => {
        if (res.data[v.symbol]) {
          v.price = res.data[v.symbol]
          v.changes_percentage = ((Number(v.price) - Number(v.previous_close)) / Number(v.previous_close) * 100).toFixed(2)
        }
      })
    }
  })
}
const { start, stop } = usePolling(() => {
  return getStockPrice()
}, 2000)  // 3 秒轮询一次
start()

// 收藏/取消
function stockToggleClick(v) {
  stockToggle({
    id: v.id,
    type: v.collect ? 2 : 1
  }).then(res => {
    if (res.code == 200) {
      if (active.value == 0) {
        list.value = []
        page.value = 1
        finished.value = false
        loading.value = false
        key.value = !key.value
      }
      if (v.collect) {
        v.collect = false
      } else {
        v.collect = true
        mainStore.setIs_collect(1)
      }
      setTimeout(() => {
        showSuccessToast(res.message)
      }, 50)
    }
  })
}
// 收藏
function getShoucang() {
  stockListCollect({
    page: page.value,
    size: size.value,
    sort: sort.value
  }).then(res => {
    if (res.code == 200) {
      list.value = list.value.concat(res.data.list)
      stock_symbolList = list.value.map(v => v.symbol)
      loading.value = false;
      page.value++
      if (res.data.list.length < size.value) {
        finished.value = true;
      }
      if (list.value.length == 0) {
        mainStore.setIs_collect(0)
      }
    }
  })
}
// 股票
function getStockList(closeLoading) {
  stockList({
    page: page.value,
    size: size.value,
    type: active.value == 1 ? 'AR' : active.value == 2 ? 'US' : '',
    // sort: sort.value,
    sort_field: sort_field.value, //price价格排序  changes_percentage涨幅排序
    sort_order: sort.value == 1 ? 'asc' : sort.value == 2 ? 'desc' : undefined, //asc升序 desc 降序
    keyword: nameStr.value
  }, closeLoading).then(res => {
    if (res.code == 200) {
      list.value = list.value.concat(res.data.list)
       stock_symbolList = list.value.map(v => v.symbol)
      loading.value = false;
      page.value++
      if (res.data.list.length < size.value) {
        finished.value = true;
      }
    }
  })
}
// 资讯
function getArticleList() {
  articleList({
    page: page.value,
    size: size.value,
  }).then(res => {
    if (res.code == 200) {
      list.value = list.value.concat(res.data)
      loading.value = false;
      page.value++
      if (res.data.length < size.value) {
        finished.value = true;
      }
    }
  })
}
function tabChange(e) {
  if (active.value != e) {
    list.value = []
    stock_symbolList = []
    page.value = 1
    finished.value = false
    loading.value = false
    active.value = e
    key.value = !key.value
    setTimeout(() => {
      scrollActiveToCenter(e)
    }, 10)
  }
}

// 排序
function sortClick(e) {
  if (e != sort_field.value) {
    sort_field.value = e
    sort.value = 0
  }
  sort.value++
  if (sort.value > 2) {
    sort.value = 0
  }
  list.value = []
  page.value = 1
  finished.value = false
  loading.value = false
  key.value = !key.value
}

function newsClick(v) {
  sessionStorage.setItem('newsContent', JSON.stringify(v))
  router.push('/newsDetail')
}
// 自动滚动到中间
const tabWrap = ref(null)
const tabRefs0 = ref(null)
const tabRefs1 = ref(null)
const tabRefs2 = ref(null)
const tabRefs3 = ref(null)
const tabRefs4 = ref(null)
const tabRefs5 = ref(null)
const tabRefs6 = ref(null)
function scrollActiveToCenter(index) {
  const wrap = tabWrap.value
  let tab = null
  if (index == 0) {
    tab = tabRefs0.value
  }
  if (index == 1) {
    tab = tabRefs1.value
  }
  if (index == 2) {
    tab = tabRefs2.value
  }
  if (index == 3) {
    tab = tabRefs3.value
  }
  if (index == 4) {
    tab = tabRefs4.value
  }
  if (index == 5) {
    tab = tabRefs5.value
  }
  if (index == 6) {
    tab = tabRefs6.value
  }
  if (!wrap || !tab) return

  const wrapWidth = wrap.clientWidth
  const tabWidth = tab.offsetWidth
  const tabLeft = tab.offsetLeft

  // 目标滚动位置 = tab 的中心点 - 容器宽度的一半
  const targetScrollLeft = tabLeft - (wrapWidth / 2) + (tabWidth / 2)

  wrap.scrollTo({
    left: targetScrollLeft,
    behavior: 'smooth'
  })
}

// 监听 股票列表 订阅价格
let subs = []
watch(list, (newVal, oldVal) => {
  if (newVal.length) {
    if (active.value != 3) {
      webSocketSendSubs = newVal.map(v => {
        return { type: 'stock', symbol: v.short_name, country: v.country || 'US' }
      })
      subs = webSocketSendSubs.concat(webSocketSendSubsIndexs)
    }else{
      webSocketSendSubs = []
    }
    send({
      action: 'subscribe',
      subs: subs
    })
  }
})

// ===== 初始化 WebSocket =====
let offWS = null
const initWebSocket = () => {
  offWS = useIndexWS({
    action: 'subscribe',
    subs: []
  }, res => {
    // console.log(res, '////');
    // 指数
    if (res.type == 'index') {
      indexs.value.forEach(v => {
        if (v.cfd_t == res.data.symbol) {
          v.price = res.data.c
          v.profit_and_Loss = v.price - v.previous_close
          if (v.previous_close <= 0) {
            v.increase = 0
          } else {
            v.increase = (v.price - v.previous_close) / v.previous_close * 100
          }
        }
      })
    }
    // 股票
    if (res.type == 'stock') {
      list.value.forEach(v => {
        if (v.short_name == res.data.symbol && v.country == res.data.co) {
          v.price = res.data.c
          if (v.previous_close <= 0) {
            v.changes_percentage = 0
          } else {
            v.changes_percentage = (v.price - v.previous_close) / v.previous_close * 100
          }
        }
      })
    }
  })
}
initWebSocket()
getIndexsList()

onBeforeUnmount(() => {
  offWS && offWS()
})
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 75px;
  min-height: 100vh;

  .market-search {
    display: flex;
    align-content: center;
    justify-content: center;

    .market-search-ipt {
      flex: 1;
      gap: 10px;
    }
  }

  .list-page {
    margin: 15px;
    border-radius: 10px;
    min-height: 100px;

    .trade-tbas {
      background: #fff;
      display: flex;
      align-content: center;
      justify-content: flex-start;
      border-radius: 14px;
      overflow: auto;
      cursor: grab;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
      overflow-x: auto;
      scroll-behavior: smooth;
      scrollbar-width: none;
      -ms-overflow-style: none;
      margin-bottom: 15px;

      div {
        flex: 1;
        color: #999;
        font-size: 13px;
        padding: 8px 20px;
        border-radius: 14px;
        white-space: nowrap;
      }

      div {
        text-align: center;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        // transition: all 0.3s;
      }

      .trade-tbas-is {
        background-color: #2969FF;
        color: #fff;
        font-size: 14px;
      }
    }

    .list-th {
      display: flex;
      margin-top: 15px;
      margin-bottom: 5px;
      gap: 10px;
      padding-left: 20px;

      div {
        font-size: 12px;
        font-weight: 400;
        line-height: normal;
        letter-spacing: normal;
        color: #a2a7aa;
        width: calc(50% - 20px);
      }

      div:nth-child(2) {
        width: 25%;
      }

      .list-th-right {
        display: flex;
        align-content: center;
        justify-content: center;
      }

      div:last-child {
        width: 25%;
        text-align: right;
      }

      .list-th-right-icon {
        display: flex;
        align-content: center;
        justify-content: center;
        flex-direction: column;
        position: relative;

        .icon-fall {
          margin-top: -3px;
        }

        .icon {
          font-size: 11px;
        }
      }
    }

    .list {

      .list-row {
        display: flex;
        align-items: center;
        padding: 10px 20px;
        background: #fff;
        margin-bottom: 15px;
        border-radius: 10px;
        gap: 10px;

        .list-col1 {
          flex-shrink: 0;
          width: 51%;
          display: flex;
          align-items: center;
          gap: 10px;

          .cursor-pointer {
            width: 18px;
            height: 18px;
          }

          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }

          .stock-name {
            margin-left: 10px;
            font-size: 11px;
            flex: 1;
            overflow: hidden;

            div:last-child {
              font-size: 12px;
              color: #a2a7aa;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              /* 最多显示3行 */
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .list-col2 {
          width: 30%;

          .list-text1 {
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0;
            color: #000;
            transition: transform .3s ease;
          }
        }

        .list-col3 {
          width: 25%;
          word-wrap: break-word;

          .list-text2 {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 900;
            line-height: 18px;
            text-align: right;
            letter-spacing: 0;
            color: #15b384;
            white-space: nowrap;
            transition: transform .3s ease;

            &.zhang {
              color: #cb0000;
            }
          }
        }
      }


    }

    // .news-item {
    //   border-radius: 6px;
    //   opacity: 1;
    //   background: #fff;
    //   box-sizing: border-box;
    //   margin-bottom: 12px;
    //   display: flex;
    //   align-items: center;
    //   overflow: hidden;
    //   padding: 15px;
    //   gap: 15px;

    //   .right {
    //     flex: 1;

    //     .news-item-title {
    //       font-family: Source Han Sans;
    //       font-size: 12px;
    //       font-weight: 600;
    //       color: #000;
    //       padding: 10px 0 0 10px;
    //       display: -webkit-box;
    //       -webkit-box-orient: vertical;
    //       -webkit-line-clamp: 3;
    //       line-clamp: 3;
    //       text-overflow: ellipsis;
    //       line-height: 1.5;
    //       overflow: hidden;
    //     }

    //     .news-item-footer {
    //       padding: 0 10px;
    //       margin-top: 10px;

    //       .news-item-footer-left {
    //         font-family: Alibaba PuHuiTi 3;
    //         font-size: 13px;
    //         font-weight: 500;
    //         color: #8c91a2;
    //       }
    //     }
    //   }

    //   .news-item-img {
    //     height: 80px;
    //     width: 80px;
    //     border-radius: 6px;
    //     overflow: hidden;

    //     img {
    //       width: 100%;
    //       height: 100%;
    //     }
    //   }
    // }
    .news-item.no-image {
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 10px;
      padding: 14px 16px;
      margin-bottom: 12px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
      transition: all 0.2s ease;
      cursor: pointer;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
      }

      .news-content {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .news-item-title {
        font-size: 15px;
        font-weight: 600;
        color: #111;
        line-height: 1.5;
      }

      .news-item-summary {
        font-size: 13px;
        color: #555;
        line-height: 1.6;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        overflow: hidden;
      }

      .news-item-tags {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 4px;

        .tags {
          display: flex;
          gap: 4px;

          .tag {
            background: #eef5ff;
            color: #2969ff;
            padding: 2px 6px;
            font-size: 11px;
            border-radius: 10px;
          }
        }

        .sentiment {
          font-size: 12px;

          &.positive {
            color: #16a34a;
          }

          &.negative {
            color: #dc2626;
          }
        }
      }

      .news-item-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        color: #8c91a2;
        margin-top: 8px;

        .read-more {
          color: #2969ff;
          font-weight: 500;
        }
      }
    }

  }
}
</style>
